module.exports = __webpack_public_path__ + "static/media/the_fight_for_food_security-desktop.dea0369a.jpg";